import { render, staticRenderFns } from "./DetailTicketEvent.vue?vue&type=template&id=b9db506e&scoped=true&"
import script from "./DetailTicketEvent.vue?vue&type=script&lang=js&"
export * from "./DetailTicketEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db506e",
  null
  
)

export default component.exports